<template>
    <div>
        <stat-box
            v-if="project.estimated_incidence_rate > 0"
            :value="incidenceRate"
            postfix="%"
            hint="Incidence rate"
            :color="incidenceColor"
            :hintAtTop="true"
            mouse-over-color="primary"
            :mouseOverValue="project.estimated_incidence_rate"
            mouseOverHint="Estimated incidence"
            mouse-over-postfix="%"
            :height="height">
        </stat-box>
        <stat-box
            v-else
            :value="incidenceRate"
            postfix="%"
            hint="Incidence rate"
            :color="incidenceColor"
            :hintAtTop="true"
            :height="height">
        </stat-box>
    </div>

</template>

<script>

import StatBox from "../../../components/UI/StatBoxNumerical";

const vuexModule = 'VuexStore';

export default {

    components: {
        StatBox
    },

    props: {
        project: {
            type: Object,
            required: true
        },
        height: {
            type: Number,
            required: false,
            default: 100
        },
    },

    computed: {

        incidenceRate() {
            if (this.project.completed_count > 0) {
                return Math.round(this.project.completed_count / (this.project.completed_count + this.terminates) * 100);
            }
            return 0;
        },

        incidenceColor() {
            if (this.incidenceRate === 0) return 'grey darken-1';
            if (this.project.estimated_incidence_rate === 0 || this.incidenceAlarmPercent === 0) return 'primary';
            if (this.incidenceDeviationPercent > this.incidenceAlarmPercent) return 'red';
            if (this.incidenceDeviationPercent > this.incidenceAlarmPercent * 0.66) return 'orange darken-3';
            if (this.incidenceDeviationPercent > this.incidenceAlarmPercent * 0.33) return 'amber darken-3';
            if (this.incidenceDeviationPercent > 0) return 'yellow darken-3';
            return 'green';
        },

        incidenceDeviationPercent() {
            if (this.incidenceRate && this.project.estimated_incidence_rate > 0) {
                if (this.incidenceRate < this.project.estimated_incidence_rate) {
                    return 100 - Math.round(this.incidenceRate / this.project.estimated_incidence_rate  * 100);
                }
            }
            return 0;
        },

        incidenceAlarmPercent() {
            return this.$store.state.PanelSettings.settings.incidence_alarm_threshold;
        },

        terminates() {
            return this.project.profile_count +
                this.project.quota_count +
                this.project.profile_count +
                this.project.quality_count +
                this.project.duplicate_count;
        },
    }
}
</script>
